import { render, staticRenderFns } from "./PanelPreviewActions.vue?vue&type=template&id=1b080ade&scoped=true"
import script from "./PanelPreviewActions.vue?vue&type=script&lang=js"
export * from "./PanelPreviewActions.vue?vue&type=script&lang=js"
import style0 from "./PanelPreviewActions.vue?vue&type=style&index=0&id=1b080ade&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b080ade",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QBtn});
